import React from 'react'
import { Link } from 'gatsby'
import logo from '../img/logo.png'

const Navbar = class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false,
      navBarActiveClass: '',
    }
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
              navBarActiveClass: 'is-active',
            })
          : this.setState({
              navBarActiveClass: '',
            })
      }
    )
  }

  render() {
    return (
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main-navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item" title="Homepage">
              <img src={logo} alt="Heima er best" style={{ width: '88px' }} />
            </Link>
            {/* Hamburger menu */}
            <div
              className={`navbar-burger burger ${this.state.navBarActiveClass}`}
              data-target="navMenu"
              onClick={() => this.toggleHamburger()}
            >
              <span />
              <span />
              <span />
            </div>
          </div>
          <div id="navMenu" className={`navbar-menu ${this.state.navBarActiveClass}`}>
            <div className="navbar-start has-text-centered">
              <div className="navbar-item has-dropdown is-hoverable">
                <Link className="navbar-item" activeClassName="active" to="/product/">Markaðstorgið</Link>
              </div>
              <div className="navbar-item">
                <Link className="navbar-item" activeClassName="active" to="/pricing/">Enginn kostnaður</Link>
              </div>
              <div className="navbar-item">
                <Link className="navbar-item" activeClassName="active" to="/setup/">Uppsetning</Link>
              </div>
              <div className="navbar-item">
                <Link className="navbar-item" activeClassName="active" to="/faq/">Spurt og svarað</Link>
              </div>
              
              <div className="navbar-item ">
                <Link className="navbar-item" activeClassName="active" to="/about/">Um okkur</Link>
              </div>
            </div>
            <div className="navbar-end">
              <div className="navbar-item">
                <div className="buttons">
                  <Link to="/sign-up/" className="button is-primary">Skrá fyrirtæki</Link>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar
